import React, { useContext } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import LandingPage from './pages/LandingPage';
import Register from './pages/Register';
import Login from './pages/Login';
import MinhasListas from './pages/MinhasListas';
import ListaDeCompras from './pages/ListaDeCompras';
import Perfil from './pages/Perfil';
import { AuthContext } from './context/AuthContext';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { authData } = useContext(AuthContext);

  if (!authData.token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const GuestRoute = ({ children }) => {
  const { authData } = useContext(AuthContext);

  if (authData.token) {
    return <Navigate to="/listas" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <div className="app-shell">
        <Navbar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route
            path="/register"
            element={
              <GuestRoute>
                <Register />
              </GuestRoute>
            }
          />
          <Route
            path="/login"
            element={
              <GuestRoute>
                <Login />
              </GuestRoute>
            }
          />
          <Route
            path="/listas"
            element={
              <ProtectedRoute>
                <MinhasListas />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lista/:id"
            element={
              <ProtectedRoute>
                <ListaDeCompras />
              </ProtectedRoute>
            }
          />
          <Route
            path="/perfil"
            element={
              <ProtectedRoute>
                <Perfil />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
